import { IconWaitCondition } from '@components/icons/icon-wait-condition';
import { hideSidebar, Sidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ActionSidebarLoading, SidebarProps } from 'ui/journey-builder/node-types/common';

import { WaitForAttributeChangeFormContent } from './helpers';

type ActionType = 'wait_for_attribute_change';

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { t } = useScopedTranslate(sidebarLocale);

  const editMutation = useUpdateJourneyAction(journeyActionId);

  const { data, isLoading } = useJourneyAction<ActionType>(journeyActionId);

  if (isLoading || !data) {
    return (
      <ActionSidebarLoading
        title={t('waitForAttributeChange')}
        icon={IconWaitCondition}
        iconColor="orange100"
        {...props}
      />
    );
  }

  return (
    <Sidebar>
      <Sidebar.SimpleHeader
        title={t('waitForAttributeChange')}
        icon={IconWaitCondition}
        iconColor="orange100"
        {...props}
      />
      <Sidebar.Content>
        <WaitForAttributeChangeFormContent
          action={data}
          journeyId={data.journey}
          onCancel={hideSidebar}
          onSubmit={(submitData) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: 'wait_for_attribute_change',
              values: submitData,
              description: submitData.description ?? '',
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    waitForAttributeChange: 'Wait for field change',
  },
};
